import {Link} from '@primer/react'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {ParameterValue, SchemaField} from '@github-ui/repos-rules-types/rules-types'
import {RestrictHelper} from './RestrictHelper'

type FilePathListProps = {
  field: SchemaField
  value: ParameterValue
  onValueChange?: (value: string[]) => void
  readOnly?: boolean
  boxName: string
  buttonName: string
  blankslate: string
}

export function FilePathList({
  field,
  value,
  onValueChange,
  readOnly,
  boxName,
  buttonName,
  blankslate,
}: FilePathListProps) {
  const ignoredFilePathsEnabled = isFeatureEnabled('rule_ignored_file_paths')
  const filePaths = (value as string[] | undefined) ?? []

  return (
    <RestrictHelper
      value={filePaths}
      onValueChange={onValueChange}
      readOnly={readOnly}
      boxName={boxName}
      buttonName={buttonName}
      subtitle={
        <>
          {field.description} Supports{' '}
          {ignoredFilePathsEnabled ? (
            <Link inline href="https://man7.org/linux/man-pages/man3/fnmatch.3.html">
              fnmatch patterns
            </Link>
          ) : (
            'fnmatch patterns'
          )}{' '}
          for files and folders.
        </>
      }
      label="File path"
      examples="Example: `.github/**/*`"
      blankslate={blankslate}
      validationError={(path: string) => {
        if (path.length > 200) {
          return 'File path is too long. Maximum length is 200 characters'
        }
        return ''
      }}
    />
  )
}
